import { useState } from 'react';
import type { ChoicesStaticOptions } from '../types';

export const useBarHover = () => {
  const [hoveredBarId, setHoveredBarId] = useState<
    ChoicesStaticOptions['id'] | null
  >(null);

  const onBarHover = (barId: ChoicesStaticOptions['id'] | null) => {
    setHoveredBarId(barId);
  };

  const isBarHovered = (barId: ChoicesStaticOptions['id']) => {
    return barId === hoveredBarId;
  };

  return {
    onBarHover,
    isBarHovered,
  };
};
